var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
export default styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin: 0;\n  padding: 0;\n  display: inline-flex;\n  flex-grow: 1;\n  align-items: flex-start;\n  justify-content: flex-end;\n  flex-direction: column;\n  min-height: ", ";\n"], ["\n  margin: 0;\n  padding: 0;\n  display: inline-flex;\n  flex-grow: 1;\n  align-items: flex-start;\n  justify-content: flex-end;\n  flex-direction: column;\n  min-height: ", ";\n"])), function (_a) {
    var ignoreMinHeight = _a.ignoreMinHeight, theme = _a.theme;
    return (ignoreMinHeight ? "auto" : theme.spacing.eight);
});
var templateObject_1;
